import React from 'react'
import PropTypes from 'prop-types'
import { Chip } from '@mui/material'

const STATUS_CHIP_COLORS = {
  Green: { backgroundColor: '#def0d7', color: '#5ca044' },
  Yellow: { backgroundColor: '#fff8ea', color: '#ffaf14' },
  Red: { backgroundColor: '#fff2f2', color: '#ff1e1e' },
  Blue: { backgroundColor: '#b1d9ff', color: '#0059ae' },
  Lavender: { backgroundColor: '#e6e6fa', color: '#5c5cbf' },
}

export const OperationStatusChip = ({ label, chipColor, size = 'small' }) => {
  if (!label) return null

  const palette = STATUS_CHIP_COLORS[chipColor] || {
    backgroundColor: 'grey.200',
    color: 'text.primary',
  }

  return (
    <Chip
      size={size}
      label={label}
      sx={{
        fontWeight: 600,
        fontSize: '0.75rem',
        height: 24,
        backgroundColor: palette.backgroundColor,
        color: palette.color,
        '& .MuiChip-label': { px: 1 },
      }}
    />
  )
}

OperationStatusChip.propTypes = {
  label: PropTypes.string,
  chipColor: PropTypes.string,
  size: PropTypes.oneOf(['small', 'medium']),
}
